import { getOrCreateBubble } from './common';

const _fileExt = (fileName) => (fileName.split('.').pop() || '?').toLowerCase();

export const revokeBlobUrls = (container) => {
  container.querySelectorAll('img[src^="blob:"], a[href^="blob:"]').forEach((el) => {
    URL.revokeObjectURL(el.src || el.href);
  });
};

const _buildFileCard = (fileName, fileExt, baseClass, fileUrl) => {
  const el = document.createElement('div');
  el.className = `${baseClass} file-card`;

  const icon = document.createElement('div');
  icon.className = `file-type-icon ${fileExt}`;
  icon.textContent = fileExt;
  el.appendChild(icon);

  const info = document.createElement('div');
  info.className = 'file-info';

  const name = document.createElement('div');
  name.className = 'file-name';
  name.textContent = fileName;
  info.appendChild(name);

  const label = document.createElement('div');
  label.className = 'file-ext-label';
  label.textContent = fileExt.toUpperCase();
  info.appendChild(label);

  el.appendChild(info);

  const link = document.createElement('a');
  link.href = fileUrl;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.style.textDecoration = 'none';
  link.style.color = 'inherit';
  link.style.position = 'relative';
  link.appendChild(el);
  return link;
};

const _buildImageCard = (imgSrc, baseClass) => {
  const el = document.createElement('div');
  el.className = baseClass;
  const img = document.createElement('img');
  img.src = imgSrc;
  el.appendChild(img);

  el.classList.add('aws-chatkit-image-card');
  el.dataset.lightboxSrc = imgSrc;
  return el;
};

export const appendAttachment = (messageGroup, file) => {
  const bubble = getOrCreateBubble(messageGroup);

  const blobUrl = URL.createObjectURL(file);

  const card = file.type.startsWith('image/')
    ? _buildImageCard(blobUrl, 'aws-chatkit-message-attachment')
    : _buildFileCard(file.name, _fileExt(file.name), 'aws-chatkit-message-attachment', blobUrl);

  bubble.appendChild(card);
};

export const clearAttachmentPreviews = (container) => {
  const previewArea = container.querySelector('.aws-chatkit-attachments-preview');
  if (!previewArea) return;
  revokeBlobUrls(previewArea);
  previewArea.innerHTML = '';
  previewArea.classList.remove('has-files');
};

export const appendAwsAttachment = (messageGroup, attachment, attachmentUrl) => {
  const bubble = getOrCreateBubble(messageGroup);

  const card = attachment.ContentType.startsWith('image/')
    ? _buildImageCard(attachmentUrl, 'aws-chatkit-message-attachment')
    : _buildFileCard(attachment.AttachmentName, _fileExt(attachment.AttachmentName), 'aws-chatkit-message-attachment', attachmentUrl);

  bubble.appendChild(card);
};

export const appendAttachmentPreview = (container, file, onRemove) => {
  const previewArea = container.querySelector('.aws-chatkit-attachments-preview');
  if (!previewArea) return;

  previewArea.classList.add('has-files');

  const blobUrl = URL.createObjectURL(file);

  const card = file.type.startsWith('image/')
    ? _buildImageCard(blobUrl, 'aws-chatkit-attachment-thumb')
    : _buildFileCard(file.name, _fileExt(file.name), 'aws-chatkit-attachment-thumb', blobUrl);

  const removeBtn = document.createElement('button');
  removeBtn.className = 'aws-chatkit-attachment-remove';
  removeBtn.innerHTML = '&#10005;';
  removeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    URL.revokeObjectURL(blobUrl);
    onRemove();
  });
  card.appendChild(removeBtn);

  previewArea.appendChild(card);
};
